/* @flow */
import UsersShareJoinUrl from './UsersShareJoinUrl';

export default UsersShareJoinUrl;
